// extracted by mini-css-extract-plugin
export default {"tokenText":"HeaderIssueType-module__tokenText--XG3kt","smallToken":"HeaderIssueType-module__smallToken--TDqWJ","IssueTypeToken":"HeaderIssueType-module__IssueTypeToken--C2d57"};